"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessHighchartsCalculations = void 0;
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const highcharts_1 = __importDefault(require("highcharts"));
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const StickinessCalculations_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/state/data/highcharts/StickinessCalculations");
const lodash_1 = __importDefault(require("lodash"));
const HighchartsCalculationsCommonUtils_1 = require("src/hello_assets/src/util/HighchartsCalculationsCommonUtils");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const HighchartsOptionsProviderCommon_1 = require("src/hello_assets/src/util/HighchartsOptionsProviderCommon");
const calculateRestOptions = (series, params) => {
    const isOvertimeChart = params.chartType === StickinessChartSettingsJSONModel_1.ChartType.overtime;
    const isCumulative = params.lineType === LineTypeJSONModel_1.LineType.cumulative;
    let title = "";
    if (isOvertimeChart) {
        title = isCumulative ? `Cumulative Stickiness Over Time` : `Non-Cumulative Stickiness Over Time`;
    }
    else {
        title = isCumulative ? `Cumulative Stickiness` : `Non-Cumulative Stickiness`;
    }
    let xAxisOptions = {};
    if (isOvertimeChart) {
        xAxisOptions = {
            ...xAxisOptions,
            dateTimeLabelFormats: DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.xAxis.dateTimeLabelFormats,
            type: 'datetime',
            minTickInterval: 24 * 60 * 60 * 1000,
        };
    }
    else {
        xAxisOptions = {
            ...xAxisOptions,
            allowDecimals: false,
            labels: {
                formatter: function () {
                    return StickinessCalculations_1.StickinessCalculations.getPeriodName(isCumulative, lodash_1.default.toNumber(this.value) + 1, this.axis.getExtremes().dataMax + 1);
                }
            }
        };
    }
    let yAxisOptions = {
        min: 0,
        title: { text: '' },
        stackLabels: {
            enabled: true,
            style: { fontWeight: 'bold' }
        },
        labels: {
            formatter: function () {
                return this.value + "%";
            }
        }
    };
    if (!isOvertimeChart) {
        yAxisOptions.max = 100;
    }
    else {
        yAxisOptions.maxPadding = 0;
    }
    const tooltip = {
        useHTML: true,
        shared: true,
        formatter: function () {
            var _a;
            if (true) {
                const x = this.x;
                const dateCorrected = new Date(x).getTime();
                const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, dateCorrected);
                if (isOvertimeChart) {
                    let pointsTableHTML = HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableOpen();
                    lodash_1.default.each(this.points, ctx => {
                        // @ts-ignore
                        const { periodValue, periodLength, retentionSizes, cohortSizes } = ctx.series.options.custom;
                        const pointValue = ctx.y;
                        const period = StickinessCalculations_1.StickinessCalculations.getPeriodName(isCumulative, periodValue, periodLength);
                        const resultRetentionSize = retentionSizes[ctx.point.index];
                        const resultCohortSize = cohortSizes[ctx.point.index];
                        pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, `${period}`, `${pointValue}%`, ` (${resultRetentionSize} of ${resultCohortSize})`);
                    });
                    pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableClose();
                    const headerHTML = `<span>${date}</span><br/>`;
                    return `${headerHTML}${pointsTableHTML}`;
                }
                else {
                    let pointsTableHTML = HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableOpen();
                    const frequencyValue = x + 1;
                    const frequencyLength = (((_a = lodash_1.default.first(this.points)) === null || _a === void 0 ? void 0 : _a.series.xAxis.getExtremes().dataMax) || 0) + 1;
                    const period = StickinessCalculations_1.StickinessCalculations.getPeriodName(isCumulative, frequencyValue, frequencyLength);
                    lodash_1.default.each(this.points, ctx => {
                        // @ts-ignore
                        const { isAvg, retentionSizes } = ctx.series.options.custom;
                        const pointValue = ctx.y;
                        const pointIndex = ctx.point.index;
                        const retentionSize = retentionSizes[pointIndex];
                        if (isAvg) {
                            // @ts-ignore
                            const { totalCohortSizes, significantRetentionCounts } = ctx.series.options.custom;
                            const significantRetentionCount = significantRetentionCounts[x];
                            const totalCohortSize = totalCohortSizes[ctx.point.index];
                            const resultRetentionSize = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(retentionSize / significantRetentionCount, 2);
                            const resultCohortSize = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(totalCohortSize / significantRetentionCount, 2);
                            pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, "AVG", `${pointValue}%`, ` (${resultRetentionSize} of ${resultCohortSize})`);
                        }
                        else {
                            // @ts-ignore
                            const { date, cohortSize } = ctx.series.options.custom;
                            pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.pointRow(ctx.color, date, `${pointValue}%`, ` (${retentionSize} of ${cohortSize})`);
                        }
                    });
                    pointsTableHTML += HighchartsOptionsProviderCommon_1.HighchartsOptionsProviderCommon.TooltipFormatter.shared.tableClose();
                    const headerHTML = `<b>${period}</b><br/>`;
                    return `${headerHTML}${pointsTableHTML}`;
                }
            }
            else {
                const point = this.point;
                const value = point.y;
                const series = point.series;
                // console.log("series.options.custom", series.options.custom);
                const symbol = "<span style='color:" + this.color + "'>\u25CF</span>";
                if (isOvertimeChart) {
                    const dateCorrected = new Date(this.x).getTime();
                    const date = highcharts_1.default.dateFormat(DateTimeFacade_1.HighchartsDateFormatByFunctionality.Common.tooltip.daily, dateCorrected);
                    // @ts-ignore
                    const { periodValue, periodLength, retentionSizes, cohortSizes } = series.options.custom;
                    const period = StickinessCalculations_1.StickinessCalculations.getPeriodName(isCumulative, periodValue, periodLength);
                    const resultRetentionSize = retentionSizes[this.point.index];
                    const resultCohortSize = cohortSizes[this.point.index];
                    return `<small>${date}</small><br/>${symbol} ${period}: <b>${value}%</b> (${resultRetentionSize} of ${resultCohortSize})`;
                }
                else {
                    // @ts-ignore
                    const { isAvg, retentionSizes } = series.options.custom;
                    const pointIndex = point.index;
                    const retentionSize = retentionSizes[pointIndex];
                    const frequencyValue = this.x + 1;
                    const frequencyLength = this.series.xAxis.getExtremes().dataMax + 1;
                    if (isAvg) {
                        // @ts-ignore
                        const { totalCohortSizes, significantRetentionCounts } = series.options.custom;
                        const significantRetentionCount = significantRetentionCounts[this.x];
                        const totalCohortSize = totalCohortSizes[this.point.index];
                        const resultRetentionSize = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(retentionSize / significantRetentionCount, 2);
                        const resultCohortSize = (0, HighchartsCalculationsCommonUtils_1.numberFormat)(totalCohortSize / significantRetentionCount, 2);
                        const period = StickinessCalculations_1.StickinessCalculations.getPeriodName(isCumulative, frequencyValue, frequencyLength);
                        return `<b>${period}</b><br/>${symbol} AVG: <b>${value}%</b> (${resultRetentionSize} of ${resultCohortSize})`;
                    }
                    else {
                        // @ts-ignore
                        const { date, cohortSize } = series.options.custom;
                        const period = StickinessCalculations_1.StickinessCalculations.getPeriodName(isCumulative, frequencyValue, frequencyLength);
                        return `<b>${period}</b><br/>${symbol} ${date}: <b>${value}%</b> (${retentionSize} of ${cohortSize})`;
                    }
                }
            }
        }
    };
    let subtitle = undefined;
    if (params.shouldAddPeriod && !isOvertimeChart) {
        const initialDateMillis = params.response.intervalStartTimeSec * 1000;
        const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(initialDateMillis).startOf("day");
        const dateFrom = DateTimeFacade_1.DateTimeFacade.Formatters.HumanReadable.Common.formatToDateLocalizedFormat(initialMoment);
        const dateTo = DateTimeFacade_1.DateTimeFacade.Formatters.HumanReadable.Common.formatToDateLocalizedFormat(DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentTime());
        subtitle = { text: dateFrom + ' - ' + dateTo };
    }
    const options = {
        chart: { zoomType: "x" },
        exporting: {
            filename: (0, HighchartsCalculationsCommonUtils_1.getExportFilename)(title)
        },
        title: { text: title },
        subtitle: subtitle,
        xAxis: xAxisOptions,
        yAxis: yAxisOptions,
        tooltip: tooltip,
        series: series
    };
    return options;
};
const optionsForClassic = (params) => {
    const series = StickinessCalculations_1.StickinessCalculations.calculateClassicSeries(params);
    return calculateRestOptions(series, params);
};
const optionsForOvertime = (params) => {
    const series = StickinessCalculations_1.StickinessCalculations.calculateOvertimeSeries(params);
    return calculateRestOptions(series, params);
};
const optionsFor = (params) => {
    const response = params.response;
    if (!response) {
        return {};
    }
    const isOvertimeChart = params.chartType === StickinessChartSettingsJSONModel_1.ChartType.overtime;
    if (isOvertimeChart) {
        return optionsForOvertime({
            ...params,
            response: response
        });
    }
    else {
        return optionsForClassic({
            ...params,
            response: response
        });
    }
};
exports.StickinessHighchartsCalculations = {
    optionsFor: optionsFor
};
